import type { PlanConfig } from "./planConfig";

export interface PaywallPlanPresentation {
  code: string;
  name: string;
  monthlyCents: number | null;
  annualCents: number | null;
  currency: string;
}

export function planDisplayName(code: string): string {
  return code
    .split("_")
    .filter(Boolean)
    .map((part) => part[0]!.toUpperCase() + part.slice(1))
    .join(" ");
}

export function paywallPlanPresentation(plan: PlanConfig): PaywallPlanPresentation {
  return {
    code: plan.tier,
    name: planDisplayName(plan.tier),
    monthlyCents: plan.priceMonthlyCents,
    annualCents: plan.priceAnnualCents,
    currency: plan.currency,
  };
}
